// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { Resources } from "../../Commons/properties/Resources.ts";
import { LinkedSystem } from "../misc/LinkedSystem.js";
import { contextMenuHandler } from "../../Utils/AppHandlers.js";
import { TerceraLinkControlTemplate } from "../../templates.js";
import { ContainerControl } from "./ContainerControl.js";
import { TerceraLinkControlConstants } from "../UtilsClasses/TerceraLinkControlConstants.js";

export let TerceraLinkControl = ContainerControl.extend({

    template:  TerceraLinkControlTemplate,
    data: function ()
    {
        return {
            btnClass: '',
            selectedLinkValue: TerceraLinkControlConstants.STATE_NONE,
            linkByAccount: false
        };
    },
    menuitems: null,
});

TerceraLinkControl.prototype.getType = function () { return 'TerceraLinkControl' };

TerceraLinkControl.prototype.oninit = function ()
{
    ContainerControl.prototype.oninit.apply(this);

    this.on('linkClick', function ()
    {
        if (!this.get('linkByAccount'))         // https://tp.traderevolution.com/entity/83015
            contextMenuHandler.Show(this.menuitems, this.getX(), this.getY() + 12);  
    });
    this.observe('selectedLinkValue', function (newVal, oldVal, key)
    {
        this.setDataByValue(newVal);
    });

    this.observe('linkByAccount', function (newVal, oldVal, key)
    {
        this.set({ btnClass: (newVal ? 'js-link-color-active' : 'js-link-color-none') })
    });

    this.observe('tooltip', function (newVal, oldVal, key)
    {
        var x = 0;
    });
};

TerceraLinkControl.prototype.oncomplete = function ()
{
    ContainerControl.prototype.oncomplete.apply(this);
    this.initContextMenu();

    Resources.onLocaleChange.Subscribe(this.localize, this);
    this.completed = true;
};

TerceraLinkControl.prototype.dispose = function ()
{
    Resources.onLocaleChange.UnSubscribe(this.localize, this);

    ContainerControl.prototype.dispose.apply(this);
};

TerceraLinkControl.prototype.localize = function ()
{
    var menuitems = this.menuitems;
    if (!menuitems) return;

    var linkDataArray = TerceraLinkControlConstants.LinkDataArray;
    var len = linkDataArray.length;
    for (var i = 0; i < len; i++)
    {
        var mi = menuitems[i];
        var textKey = linkDataArray[i].textKey;
        mi.text = Resources.getResource(textKey);
    }
};

TerceraLinkControl.prototype.setDataByValue = function (value)
{
    var i;
    var len = TerceraLinkControlConstants.LinkDataArray.length;
    let linkByAccount = this.get("linkByAccount");
    for (i = 0; i < len; i++)
    {
        var newData = TerceraLinkControlConstants.LinkDataArray[i];
        if (newData.value === value)
        {
            if (linkByAccount){
                this.set({
                    btnClass: "js-link-color-active",
                    selectedLinkValue: newData.value
                });
            }
            else
                this.set({
                    btnClass: newData.style,
                    selectedLinkValue: newData.value
                });
            break;
        }
    }
    if (this.completed)
        LinkedSystem.updateDictState(linkByAccount);
};

TerceraLinkControl.prototype.initContextMenu = function ()
{
    let linkByAccount = this.get("linkByAccount");
    var clickItemEvent = function (curItem)
    {
        var tag = curItem.tag;
        this.set({
            btnClass: tag.style,
            selectedLinkValue: tag.value
        });
    }.bind(this);

    var i;
    var len = TerceraLinkControlConstants.LinkDataArray.length;
    var items = [];
    for (i = 0; i < len; i++)
    {
        var curData = TerceraLinkControlConstants.LinkDataArray[i];
        var newItem = {};
        newItem.text = Resources.getResource(curData.textKey);
        newItem.canCheck = false;
        newItem.enabled = true;
        newItem.checked = true;
        // newItem.image = App.ThemeManager.getImageFullUrl(curData.image);
        // newItem.imageHover = App.ThemeManager.getImageFullUrl(curData.image);

        newItem.event = clickItemEvent;
        if (curData.value === TerceraLinkControlConstants.STATE_NONE && linkByAccount)
        {
            newItem.style = "js-link-color-none-acc";
            newItem.tag = { value: curData.value, style: "js-link-color-none-acc" };
        }
        else
        {
            newItem.style = curData.style;
            newItem.tag = { value: curData.value, style: curData.style };
        }
        items.push(newItem);
    }

    this.menuitems = items;
};

//window HACK
window.TerceraLinkControl  = TerceraLinkControl